import {memo, shapeComponent, ShapeComponent, Text, useBreakpoint, useI18n, View} from "shared/base"
import AppHistory from "shared/history"
import Button from "components/chalky-layout/button"
import ButtonUnderscore from "components/chalky-layout/button-underscore"
import Card from "components/chalky-layout/card"
import ChalkyLayout from "components/chalky-layout"
import PageContentsPresentation from "components/page-contents/presentation"
import React from "react"
import Routes from "shared/routes"
import setLayout from "shared/set-layout"
import useQueryParams from "on-location-changed/build/use-query-params"

export default memo(shapeComponent(class UserCreatedUserStep3Route extends ShapeComponent {
  setup() {
    setLayout("front")

    const {t} = useI18n({namespace: "js.routes.user.create_user.step3"})

    this.setInstance(useBreakpoint())
    this.setInstance({
      queryParams: useQueryParams(),
      t
    })
  }

  render() {
    const {lgUp, queryParams, t} = this.tt

    return (
      <ChalkyLayout layout="front" maxWidth={1260} menu={false} userMenu={false} weekBar={false}>
        <Text
          style={this.yourRoleDescription ||= {
            color: "#2c2c96",
            fontFamily: "DreamChaser",
            fontSize: 64,
            textAlign: "center"
          }}
        >
          {t(".welcome_to_woof")}
        </Text>
        <View
          dataSet={this.doneContentDataSet ||= {class: "done-content"}}
          style={this.cache("doneContentStyle", {
            flexDirection: lgUp ? "row" : "column",
            alignItems: "center",
            maxWidth: 846,
            marginLeft: "auto",
            marginRight: "auto"
          }, [lgUp])}
        >
          <Card style={this.cache("cardStyle", {width: 596, marginTop: lgUp ? 48 : 32})}>
            <PageContentsPresentation
              identifier="user/create-user/step-5-route/recommendation-brain-breaks"
              liquidVariables={this.recommendationLiquidVariables ||= {queryParams}}
            />
            <Button
              dataSet={this.createYourFirstClassButtonDataSet ||= {class: "create-your-first-class-button"}}
              icon="plus"
              onPress={this.tt.onCreateYourFirstClassPress}
              primary
              style={this.createYourFirstClassButtonStyle ||= {maxWidth: 298, marginTop: 16, marginRight: "auto", marginLeft: "auto"}}
              title={t(".create_your_first_class")}
            />
            <View style={this.underscoreButtonStyle ||= {alignItems: "center"}}>
              <ButtonUnderscore
                dataSet={this.skipThisStepButtonDataSet ||= {class: "go-to-your-overview-button"}}
                onPress={this.tt.onGoToYourOverviewPress}
                title={t(".go_to_your_overview")}
              />
            </View>
          </Card>
        </View>
      </ChalkyLayout>
    )
  }

  onCreateYourFirstClassPress = () => AppHistory.push(Routes.userCreateClassStep1Path())
  onGoToYourOverviewPress = () => AppHistory.push(Routes.userRootPath())
}))
